import { CreditCard } from "lucide-react";
import { Header } from "../ui/header";
export const PaymentHeader = () => {
  const paymentIcon = (
    <div className="relative">
      <CreditCard className="w-6 h-6 text-black" />
    </div>
  );
  return (
    <Header
      title="Payment"
      showBackButton={true}
      rightElement={paymentIcon}
    />
  );
};